<!-- src/App.vue -->
<template>
  <div id="app">
    <!-- 路由出口：所有页面组件都会渲染到这里 -->
    <router-view />
    <!-- 备案号 - 只在登录/注册/找回密码页面显示 -->
    <div v-if="['/', '/login', '/register', '/findPwd'].includes($route.path)" class="icp-footer">
      <a href="https://beian.miit.gov.cn/" target="_blank">鄂ICP备2026022872号-2</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    min-height: 100vh;
  }
  /* 备案号样式 - 自然显示在所有页面底部 */
  .icp-footer {
    text-align: center;
    font-size: 12px;
    color: #666;
    padding: 15px 0;
  }
  .icp-footer a {
    color: #666;
    text-decoration: none;
  }
  .icp-footer a:hover {
    color: #409eff;
  }
</style>